function initContentBlockSlider() {
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const $sliders = $(".two-up-content-block-slider");

  if (windowWidth < 1000) {
    $sliders.each(function () {
      const $this = $(this);
      if (!$this.hasClass("flickity-enabled")) {
        $this.flickity({
          cellAlign: "left",
          contain: true,
          wrapAround: true,
          prevNextButtons: false,
          pageDots: true,
        });
      }
    });
  } else {
    $sliders.filter(".flickity-enabled").flickity("destroy");
  }
}

$(document).ready(initContentBlockSlider);

// Use a unique resize timer to avoid conflicts
window.resizeTimerContentBlock = window.resizeTimerContentBlock || null;
$(window).on("resize", function () {
  clearTimeout(window.resizeTimerContentBlock);
  window.resizeTimerContentBlock = setTimeout(initContentBlockSlider, 250);
});
